import type { Mouvement } from '@mairistem/comptabilite';
import type { UserRole } from '@mairistem/finances-utils';
import type BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import MouvementAnnulerRejeterAction from '../../mouvements/liquidation/actions/MouvementAnnulerRejeterAction';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';

abstract class BaseBordereauState {
	state: BordereauStateType;

	color: string;

	libelle: string;

	step: number;

	abstract getBordereauActions(
		_bordereau: BordereauWithState,
		_userRole: UserRole,
	): BaseLiquidationAction<BordereauWithState, BordereauActionType>[];

	abstract getMouvementActions(
		userRole: UserRole,
	): BaseLiquidationAction<Mouvement, MouvementActionType>[];

	/**
	 * Annulation et rejet d'une pièce, communs aux états d'un bordereau numéroté (MouvementAnnulerRejeterAction
	 * les masque sur un bordereau d'annulation ou de rejet).
	 */
	protected getActionsAnnulationRejet(): BaseLiquidationAction<
		Mouvement,
		MouvementActionType
	>[] {
		return [
			new MouvementAnnulerRejeterAction(),
			new MouvementAnnulerRejeterAction({ estRejet: true }),
		];
	}
}

export default BaseBordereauState;
